import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
// React Icons
import { MdOutlineAddBox, MdOutlineAssessment } from 'react-icons/md'
import { TbFileInvoice } from 'react-icons/tb'
import { FaRegFolderOpen } from 'react-icons/fa'
import { AiOutlineDashboard } from 'react-icons/ai'
import { FiSettings } from 'react-icons/fi'
// Custom hooks
import { useTenant } from '../hooks'

const MenuSide = ({ openMenu, setOpenMenu }) => {
  const [t] = useTranslation('global')
  const { tenantUsername } = useTenant();
  const itemClass = `w-full ${openMenu || 'justify-center'}`
  const linkClass = `sidebar-link flex items-center gap-2 w-full ${openMenu || 'justify-center'}`
  const labelClass = 'whitespace-nowrap hidden md:flex font-bold'

  return (
    <div className={`z-50 sidebar-shell flex items-start transition-all duration-500 ease-out h-screen primary-bg-color border-b pt-4 ${openMenu ? 'fixed px-3 w-9 flex md:w-48 md:relative ' : 'fixed w-0 hidden md:flex md:w-16 md:px-3 '}`}>
      <ul className='cursor-default flex flex-col gap-2 items-center text-white text-xs w-full'>
        <li className={itemClass}>
          <NavLink to={`/${tenantUsername}`} className={linkClass} end>
            <span className="sidebar-icon"><AiOutlineDashboard size={20} title={t('menu.Dashboard')} /></span>
            {openMenu && <span className={labelClass}>{t('menu.Dashboard')}</span>}
          </NavLink>
        </li>
        <li className={itemClass}>
          <NavLink to={`/${tenantUsername}/tickets/add`} className={linkClass} end>
            <span className="sidebar-icon"><MdOutlineAddBox size={20} title={t('support.menu.createTicket')} /></span>
            {openMenu && <span className={labelClass}>{t('support.menu.createTicket')}</span>}
          </NavLink>
        </li>
        <li className={itemClass}>
          <NavLink to={`/${tenantUsername}/tickets`} className={linkClass} end>
            <span className="sidebar-icon"><TbFileInvoice size={20} title={t('support.menu.tickets')} /></span>
            {openMenu && <span className={labelClass}>{t('support.menu.tickets')}</span>}
          </NavLink>
        </li>
        <li className={itemClass}>
          <NavLink to={`/${tenantUsername}/projects`} className={linkClass}>
            <span className="sidebar-icon"><FaRegFolderOpen size={18} title={t('support.menu.projects')} /></span>
            {openMenu && <span className={labelClass}>{t('support.menu.projects')}</span>}
          </NavLink>
        </li>
        
        {/* --- إضافة عنصر التقارير الجديد فوق الإعدادات --- */}
        <li className={itemClass}>
          <NavLink to={`/${tenantUsername}/reports`} className={linkClass} end>
            <span className="sidebar-icon"><MdOutlineAssessment size={20} title={t('support.menu.reports') || 'التقارير'} /></span>
            {openMenu && <span className={labelClass}>{t('support.menu.reports') || 'التقارير'}</span>}
          </NavLink>
        </li>

        <li className={itemClass}>
          <NavLink to={`/${tenantUsername}/settings`} className={linkClass} end>
            <span className="sidebar-icon"><FiSettings size={20} title={t('support.settings.title')} /></span>
            {openMenu && <span className={labelClass}>{t('support.settings.title')}</span>}
          </NavLink>
        </li>
      </ul>
    </div>
  )
}
export default MenuSide
